/**
 * 🔐 SUPABASE CLIENT SINGLETON
 * 
 * Centralized Supabase client to avoid multiple instance warnings.
 * Import this instead of creating new clients.
 */

import { createClient } from '@supabase/supabase-js';
import { projectId, publicAnonKey } from '/utils/supabase/info';

// Create a single Supabase client instance
export const supabase = createClient(
  `https://${projectId}.supabase.co`,
  publicAnonKey
);
